import React from "react";
import styles from "./OnChangeInputField.module.css";

// This is an input field that will activate an onChange function to update state.
const OnChangeInputfield = ({ label, name, type, id, onChange, value }) => {
  return (
    <article className={styles["onchange-inputfield-wrapper"]}>
      <label htmlFor={id}>{label}</label>
      <input
        className={styles["onchange-input-field"]}
        name={name}
        type={type}
        id={id}
        autoComplete="on"
        onChange={onChange}
        value={value}
      />
    </article>
  );
};

export default OnChangeInputfield;
